import React from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "stores/Interfaces";
import { DatePicker as DatePickerAntd, Form } from "antd";
import { FieldConfig } from "components/common/forms/Interfaces";
import { Moment } from "moment";

interface Props {
  value: Moment;
  store?: IAppStore;
  name: string;
  config?: FieldConfig;
}

const DatePicker: React.FC<Props> = ({
  store,
  value,
  name,
  config,
  ...rest
}) => {
  return (
    <Form.Item
      name={name}
      label={config?.label}
      rules={config?.validationRules}
      labelCol={{ span: 24 }}
      style={{ marginBottom: 0 }}
      {...(config?.extra || {})}
      {...rest}
    >
      <DatePickerAntd key={name} style={{ height: 40 }} defaultValue={value} />
    </Form.Item>
  );
};

export default inject("store")(observer(DatePicker));
